import { toast } from "react-toastify";
import { verifyPayment } from "../apis/AppointmentApi";

export const loadRazorpay = (
  data,
  formData,
  setFormData,
  intialData,
  setLoading
) => {
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.onerror = () => {
    setLoading(false);
    toast.error("Payment gateway failed to load. Are you online?");
  };
  const { appointment, order } = data;
  script.onload = async () => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY, // Replace with your Razorpay Key ID
      amount: order.amount,
      currency: order.currency,
      name: appointment.name,
      description: "Booking appointment in Prasad Eye Hospital",
      image:
        "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/logo.png",
      order_id: order.orderId,
      handler: async function (response) {
        const verifyData = {
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          appointmentId: appointment.id,
        };

        await verifyPayment(
          verifyData,
          formData,
          setFormData,
          intialData,
          setLoading
        );
      },
      prefill: {
        name: appointment.name,
        email: appointment.email || "",
        contact: appointment.phone,
      },
      notes: {
        Name: appointment.name,
        Phone: appointment.phone,
        Email: appointment?.email,
        Address: appointment?.city,
      },
      theme: {
        color: "#3399cc",
      },
      // Handle payment cancellation
      modal: {
        ondismiss: function () {
          setLoading(false);
          toast.error("Payment cancelled by the user.");
        },
      },
      // Handle errors (network issues, failed payment, etc.)
      onError: function (response) {
        setLoading(false);
        toast.error("Payment failed. Please try again.");
        console.error(response);
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };
  document.body.appendChild(script);
};
